import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Register required Chart.js components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler, // Enables the "fill" for area charts
    Legend
);

const AreaChart = ({labels, label, dataset}) => {
    // Chart data
    const data = {
        labels,
        datasets: [
            {
                label,
                data:dataset,
                backgroundColor: 'rgba(75, 192, 192, 0.2)', // Area color
                borderColor: 'rgba(75, 192, 192, 1)', // Line color
                borderWidth: 2,
                fill: true, // Enables area fill
            },
        ],
    };

    // Chart options
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
        },
       
    };

    return <Line data={data} options={options} />;
};

export default AreaChart;
